import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import { ClientesEmDebito } from './ClientesEmDebito';

function ClientesEmDebitoPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Clientes Em Débito'));
  return (
    <ClientesEmDebito />
  );
}

export default withTokenInterceptor(ClientesEmDebitoPage);
